import axios from 'axios';

export const FETCH_ADHERENCES = 'FETCH_ADHERENCES';
export const LOOKUP_FETCH_ADHERENCES = 'LOOKUP_FETCH_ADHERENCES';
export const DOWNLOAD_ADHERENCES = 'DOWNLOAD_ADHERENCES';
export const PER_PAGE = 'PER_PAGE';
export const PAGE_NUMBER = 'PAGE_NUMBER';
export const TOTAL_PAGES = 'TOTAL_PAGES';
export const TOTAL_RESULTS = 'TOTAL_RESULTS';
export const SEARCH_ADHERENCES = 'SEARCH_ADHERENCES';
export const SEARCH_ADHERENCES_BY = 'SEARCH_ADHERENCES_BY';
export const ORDERBY = 'ORDERBY';
export const START_DATE = 'START_DATE';
export const END_DATE = 'END_DATE';
export const SEARCH_DATE_RANGE = 'SEARCH_DATE_RANGE';
export const CLEAR_SEARCH_DATES = 'CLEAR_SEARCH_DATES';
export const SEARCH_BY_PROTOCOL = 'SEARCH_BY_PROTOCOL';

export function fetchAdherences( ProtocolISDAId, perPage = 50, pageNum = 1, searchTerm = '' ) {
	return ( dispatch, getState ) => {
		const { orderBy } = getState();
		const url = `${wpApiSettings.root}isda/v1/protocol-adherence/${ProtocolISDAId}?posts_per_page=${perPage}&offset=${pageNum}&search=${searchTerm}&orderby=${orderBy.orderby}&order=${orderBy.order}`;
		axios.get( url ).then( response => {
			dispatch( {
				          type: FETCH_ADHERENCES, payload: response.data
			          } );
			dispatch( {
				          type   : TOTAL_PAGES,
				          payload: response.headers[ 'x-wp-totalpages' ] % 1 !== 0
					          ? parseInt( response.headers[ 'x-wp-totalpages' ] ) + 1
					          : response.headers[ 'x-wp-totalpages' ]

			          } );
			dispatch( {
				          type   : TOTAL_RESULTS,
				          payload: response.headers[ 'x-wp-total' ]
			          } );
		} );
	};
}

export function lookUpFetchAdherences( perPage = 50, pageNum = 1, searchTerm = '', searchBy = '', startDate = '', endDate = '', searchByProtocol = '' ) {
	return ( dispatch, getState ) => {
		const { orderBy } = getState();
		const url = `${wpApiSettings.root}isda/v1/protocol-adherence-lookup?posts_per_page=${perPage}&offset=${pageNum}&search=${searchTerm}&orderby=${orderBy.orderby}&order=${orderBy.order}&searchby=${searchBy}&startDate=${startDate}&endDate=${endDate}&searchByProtocol=${searchByProtocol}`;
		axios.get( url ).then( response => {
			dispatch( {
				          type: LOOKUP_FETCH_ADHERENCES, payload: response.data
			          } );
			dispatch( {
				          type   : TOTAL_PAGES,
				          payload: response.headers[ 'x-wp-totalpages' ] % 1 !== 0
					          ? parseInt( response.headers[ 'x-wp-totalpages' ] ) + 1
					          : response.headers[ 'x-wp-totalpages' ]

			          } );
			dispatch( {
				          type   : TOTAL_RESULTS,
				          payload: response.headers[ 'x-wp-total' ]
			          } );
		} );
	};
}

export function downloadAdherences( searchTerm = '', searchBy = '', searchStartDate = '', searchEndDate = '', searchByProtocol = '' ) {
	return ( dispatch, getState ) => {
		const { orderBy } = getState();
		const url = `${wpApiSettings.root}isda/v1/protocol-adherence-lookup?search=${searchTerm}&orderby=${orderBy.orderby}&order=${orderBy.order}&searchby=${searchBy}&startDate=${searchStartDate}&endDate=${searchEndDate}&searchByProtocol=${searchByProtocol}`;
		axios.get( url ).then( response => {
			dispatch( {
				          type: DOWNLOAD_ADHERENCES, payload: response.data
			          } );
		} );
	};
}

export function changePageCount( newCount ) {
	return (dispatch => {
			'use strict';
			dispatch( {
				          type: PER_PAGE, payload: newCount
			          } );
		}
	);
}

export function setPage( pageNum ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: PAGE_NUMBER, payload: pageNum
		          } );
	};
}

export function searchAdherences( searchTerm ) {
	return (dispatch => {
			'use strict';
			dispatch( {
				          type: SEARCH_ADHERENCES, payload: searchTerm
			          } );
		}
	);
}

export function clearSearchAdherences() {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: SEARCH_ADHERENCES, payload: ''
		          } );
	};
}

export function clearSearchDates() {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: CLEAR_SEARCH_DATES,
			          payload: { startDate: '', endDate: '' }
		          } );
	};
}

export function searchAdherencesBy( searchBy ) {
	return ( dispatch => {
			'use strict';
			dispatch( {
				          type: SEARCH_ADHERENCES_BY, payload: searchBy
			          } );
		}
	);
}

export function changeAdherenceSortBy( orderBy ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: ORDERBY, payload: orderBy
		          } );
	};
}

export function searchByProtocolName( searchByProtocol = '' ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: SEARCH_BY_PROTOCOL, payload: searchByProtocol
		          } );
	};
}

export function clearSearchByProtocol() {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: SEARCH_BY_PROTOCOL, payload: ''
		          } );
	};
}

export function searchByDateRange( searchStartDate = '', searchEndDate = '' ) {
	return (dispatch) => {
		'use strict';
		dispatch({
			         type: SEARCH_DATE_RANGE,
			         payload: { startDate: searchStartDate, endDate: searchEndDate }
		         });
	};
}